namespace('compass.demographic');

compass.require('compass.demographic.AddressWidget');
compass.requireLib('compass.util.parse');
compass.requireLib('compass.util.format');

compass.demographic.CreditCardWidget = compass.defineWidget(function CreditCardWidget(options) {
	var me = this;
	var $j = jQuery;

	var _settings = options;

	/* temporary. changes data to the way it looked before standardizing data schema in our views */
	if(_settings.translate)
	{
		var mapNewModelToOldModel = function(newPayment){
			return {
                "lastFour": newPayment.cc,
                "nameOnCard": newPayment.name_on_card,
                "paymentId": newPayment.payment_id,
                "type": newPayment.payMethodBase.name
            };
		};
		_settings.storedCards = _.map(_settings.storedCards, function(card,index) {
			return mapNewModelToOldModel(card);
		});

		_settings.currentPayment = mapNewModelToOldModel(_settings.currentPayment);
	}

	var _creditCardTypesArray = options.creditCardTypes;
	var _imgPath = options.imgPath;

	var _addressWidgetJSObject = null;
	var _validator = options.validator;
	var _ISOFormat = compass.util.dateFormatter('yyyy-mm-dd');

	// company guarantee should be editable and selectable when the user has permission and should only be editable when they do not have permission
	var companyGuaranteeException = _settings.storedCards && _settings.storedCards.length === 0 && _settings.currentPayment.type === 'Company Guarantee' && !_settings.currentPayment.hasPermission;

	var _labels = {
		security_code: {
			label: "Security Code",
			hint: "For this show, the security code on the back of the card is required"
		},
		card_type: {
			label: "",
			hint: ""
		},
		card_number: {
			label: "Credit Card Number",
			hint: "A valid credit card number is required"
		},
		experation_date: {
			label: "Expiration Date"
		},
		expiration_month: {
			hint: "A card that does not expire by the time of the reservation is required"
		},
		expiration_year: {
			hint: "A card that does not expire by the time of the reservation is required"
		},
		card_name: {
			label: "Cardholder's Name",
			hint: "The name on the card is required"
		},
		payment_select: {
			label: _settings.cardWillBeCharged ? "Deposit " : "Payment "
		}
	};

	var _skipValidation = function (input) {
		if ($(input).hasClass("hide")) {
			return _validator.IGNORED;
		}
		return _newCard ? _validator.VALID : _validator.IGNORED;
	};

	this.grabValues = function() {
		if (!_newCard) {
			return { "payment_id": _paymentSelection.val() };
		}

		var values = me.find(':input,:selected').serializeArray();
		var jsonValues = {};
		jQuery.each(values, function(i, field) {
			jsonValues[field.name] = field.value;
		});

		jsonValues.address = _addressWidgetJSObject.getAddress();

		return jsonValues;
	};

	this.getAddressWidgetJSObject = function() {
		return _addressWidgetJSObject;
	};

	this.isBillingAddressSameChecked = function() {
		return me.find("input[name='billingAddressSameAsMailing']").is(':checked');
	};

	var _setupControls = function() {
		var cb = me.find("input[name='billingAddressSameAsMailing']").change(function() {
			// this is not the this of this object, but the the checkbox itself since this is a callback.
			this.checked ? me.find('.addressWidgetDiv').hide() : me.find('.addressWidgetDiv').show();
		});

		var creditCardNumberField = me.find('input.cardNumberInput');
		// bind the key up event for the credit card number field to check for numeric input only
		creditCardNumberField.keyup(function(e) {
			if ( e.keyCode < 37 && e.keyCode > 40 )
				this.value = this.value.replace(/[^0-9\.]/g, '');
		});

		// bind the change even tfor the credit card number input to automatically change to the specific card number
		creditCardNumberField.change(function() {
			var creditCardType = _cardType(this.value);
			_changeCreditCardType(creditCardType);
		});

		var _showErrorDiv, _hideErrorDiv;
	};

	this.render = function(widgetElem) {
		var d = _d;

		_addressHolder = d.div({
			className : "creditCardWidgetAddressWidget subwidgetdiv creditCardWidgetAddressDiv"
		});

		var awo = _settings.addressWidget;
		awo.WUID =  me.getWUID();
		awo.validator = _validator;
		awo.skipFunc = _skipValidation;
		_addressWidgetJSObject = new compass.demographic.AddressWidget(_addressHolder, awo);

		var month = me.drawExpMonth();
		var year = me.drawExpYear();
		if (_validator) {
			_validator.addFields([month, year], [_skipValidation, _validator.CC_EXPIR], {
						minExpirDate: _settings.minExpiration,
						monthZeroIndexed: true
					});
		}
		var _expDateId = compass.generateId();
		var _expYearId = compass.generateId();
		widgetElem.append(
			_settings.displayHeader ? _drawHeader() : '',
			(_settings.storedCards && _settings.cardHasBeenCharged === false && !companyGuaranteeException) ? _drawStoredCards() : '',
			_settings.cardHasBeenCharged ? _drawCardAlreadyCharged() : '',
			d.div({ className : 'clear' }),
			d.div({ className : 'newCardFields' },
				d.div({ className: 'cardFields' },
					me.drawCardNumber(_settings.maskCCNumber),
					d.div({ className : 'beginCardImages' }),
					me.drawCardImages(),
					d.div({ className: 'endCardImages' }),
					d.fieldset({className: 'expDate', 'aria-labelledby': _expDateId},
						d.legend({className: 'expDateLabel', id: _expDateId}, d.label({'for': _expir_ids[0]}, _labels.experation_date.label)),
						d.div({className: 'expMonthWrapper'}, month),
						d.div({className: 'expYearWrapper'}, year)
					),
					_settings.displayCVC ? me.drawSecurityCode() : null
				),
				d.div({ className : 'endCreditCardFields' }),
				d.div({ className : 'addressFields' },
					me.drawNameOnCard(),
					d.div({ className : "endNameOnCard" }),
					_addressHolder
				),
				d.div({ className : 'clear' })
			)
		);

		//select current year for default expiration date
		var now = new Date();
		$('.expYear option[value=' + now.getFullYear().toString() + ']').attr('selected', 'selected');

		if (_settings.storedCards && !companyGuaranteeException) {
			widgetElem.children(".newCardFields").hide();
		}

		_setupControls();
	};

	this.drawSecurityCode = function () {
		var d = _d;
		var name = 'securityCode';

		var input = d.input({
			type : 'text',
			name: name,
			className: name,
			pattern : '^[0-9]{3,4}$',
			'data-required': 'true',
			'data-error-message': _labels.security_code.hint,
			'tabindex': '0',
			autocomplete: 'off'
		}).data('hint',_labels.security_code.hint);
		var securityCodeEl = d.fieldLabelPair({
			className: name,
			label: _labels.security_code.label
		}, [
			input
		]);
		if (_validator) {
			_validator.addFields(securityCodeEl.find('input'), [_skipValidation, _validator.CC_CVC], { });
		}
		return securityCodeEl;
	};

	var _drawHeader = function () {
		return _d.div({
			className: 'creditCardHeader'
		}, 'Payment');
	};

	var _addStoredCard = me.addCard = function (card) {
		if (!_.find(_creditCardTypesArray, function (type) {
			return type.display === card.type;
		})) {
			return;
		}

		_paymentSelection.children().removeAttr('selected');

		var option = _d.option({
			value: card.paymentId,
			selected: _newCard
		}, (card.nameOnCard + "'s " + card.type + ' ending in ' + card.lastFour));
		_paymentSelection.children(':last').before(option);

		if (_newCard) {
			toggleNewFields();
		}
	};
	var _paymentSelection;
	var _drawStoredCards = function () {
		_newCard = false;
		var found = false;
		var _paymentId = compass.generateId();
		_paymentSelection = _d.select({
			className: "storedCardsSelect",
			'tabindex': '0',
			id: compass.generateId(),
			name: "storedCard",
			'ARIA-labelledby': _paymentId },
			_.map(_settings.storedCards, function (card) {
				found = found || card.paymentId === _settings.currentPayment.paymentId;
				return _d.option({
					value: card.paymentId,
					selected: card.paymentId === _settings.currentPayment.paymentId
				}, card.nameOnCard + "'s " + card.type + ' ending in ' + card.lastFour);
			})
		).change(function(e) {
			var opt = _paymentSelection.val();
			me.trigger('CreditCardWidget.change', opt);
			if(opt == '__NEW__' || _newCard) {
				toggleNewFields();
			}
		});

		if (!found && _settings.currentPayment) {
			curr = _settings.currentPayment;
			_paymentSelection.append(_d.option({
				value: curr.paymentId,
				selected: true
			}, curr.type === "Company Guarantee" ? curr.type : curr.nameOnCard + "'s " + curr.type + " ending in " + curr.lastFour));
		}
		 _paymentSelection.append(_d.option({ value : '__NEW__' }, 'Add a new credit card...'));

		return _d.div(
			{ className: 'storedCardsDiv' },
			_d.reader( _d.h4('Adjust Payment') ),
			_d.span({id: _paymentId}, _labels.payment_select.label),
			_paymentSelection
		);
	};

	var _drawCardAlreadyCharged = function() {
		return _d.div({className: "alreadyCharged"}, 
			_d.span("The deposit has been charged to " + _settings.currentPayment.nameOnCard + "'s " + _settings.currentPayment.type + " ending in " + _settings.currentPayment.lastFour + ".")
		);
	};

	var _newCard = true;
	var toggleNewFields = function () {
		_newCard = !_newCard;
		me.getWidgetElem().children(".newCardFields").slideToggle(250, function () {
			if (!_newCard) {
				me.find(':input:not([name=storedCard])').val("");
				me.find('.country:input').val('UNITED STATES');
				me.find('.cardImg').show();
			}
		});
	};

	var _changeCreditCardType = function(creditCardType) {
		if(creditCardType !== undefined) {
			me.find('.cardImg').show();
			// see if the credit card code matches any of the passed in credit cards and if so, select it
			for(var i=0, len=_creditCardTypesArray.length; i<len; ++i ) {
				var currentCardType = _creditCardTypesArray[i];
				var elem = me.find("img[compass-cc-code = " + currentCardType.code + "]");
				if(currentCardType.code == creditCardType.code) {
					elem.animate({ opacity : 1 }, 600);
					elem.delay(400);
					elem.show(600);
				} else {
					elem.animate({ opacity : 0.5 }, 600);
					elem.delay(400);
					elem.hide(600);
				}
			}
		} else {
			elems = me.find('.cardImg');
			elems.animate({ opacity : 1.0 }, 10);
			elems.show(400);
		}
	};

	var _drawCreditCardOptions = function() {
		var d = _d;
		var newArray = $j.map(_creditCardTypesArray,
			function(currentElement) {
				 return d.option({
					value : currentElement.value
				}, currentElement.display);
			}
		);
		return newArray;
	};

	var _findType = function(ccCode) {
		var cardType;
		for(var i=0, len=_creditCardTypesArray.length; i<len; ++i ) {
			var currentCardType = _creditCardTypesArray[i];
			if(currentCardType.code == ccCode) {
				cardType = currentCardType;
			}
		}
		return cardType;
	};

	var _cardType = function(number) {
		var cardType;
		var firstOne 		= number.substring(0,1);
		var firstTwo		= number.substring(0,2);
		var firstThree		= number.substring(0,3);
		var firstFour		= number.substring(0,4);
		var numberLength	= number.length;
		/* once we find a particular card type, we return it if we find it in the list of valid payments passed into this widget, undefined otherwise */
		switch(numberLength) {
			case 15: {
				if(firstTwo == '34' || firstTwo == '37') {
					cardType = _findType('AM');
				}
				break;
			}
			case 13: {
				if(firstOne == '4') {
					cardType = _findType('DS');
				}
				break;
			}
			case 16: {
				if(firstFour == '6011') {
					cardType = _findType('DS');
				}
				if(parseInt(firstTwo) >= 51 && parseInt(firstTwo) <= 55) {
					cardType = _findType('MC');
				}
				if(firstOne == '4') {
					cardType = _findType('VI');
				}
				break;
			}
			case 14: {
				/* Diners Club card numbers begin with 300 through 305, 36 or 38. All have 14 digits */
				if((parseInt(firstThree) >= 300 && parseInt(firstThree) <= 305) || (firstTwo == '36' || firstTwo == '38')){
					cardType = _findType('DC');
				}
				break;
			}
		}

		return cardType;
	};

	this.drawCardType = function() {
		var d = _d;

		return d.fieldLabelPair({
			className : 'cardType',
			label : 'card type:'
		}, d.select({
			name : "cardType",
			className : "cardType cardTypeSelect"
		}, _drawCreditCardOptions()));
	};

	this.drawCardNumber = function(maskCCNumber) {
		var d = _d;

		var showCardNumber = function(maskCCNumber) {
			if (maskCCNumber) {
				var gen_id = compass.generateId();
				return d.div({ className: 'showCardNumber'},
					[d.label({ 'for': gen_id }, 'Show card number'), d.input({
						type: 'checkbox',
						className: 'showCardNumberCheckbox',
						name: 'showCardNumber',
						'tabindex': '0',
						id: gen_id
					}).change(function() {
						$('.cardNumberInput.unmasked').toggleClass('hide');
						$('.cardNumberInput.masked').toggleClass('hide');
					})]
				);
			}
			else {
				return '';
			}
		};

		var hiddenField = d.input({
			className : 'cardNumberHidden',
			type : 'hidden',
			name : 'cardNumber',
			'tabindex': '-1',
			'aria-hidden': 'true'
		});

		var inputs = [d.input({
			type : 'text',
			className : 'cardNumberInput cardNumber unmasked ' + (maskCCNumber ? 'hide' : ''),
			name : "cardNumberDummy",
			pattern : '[0-9]*',
			'tabindex': '0',
			'data-luhn': 'true',
			'data-cctype': 'true',
			'data-required': 'true',
			'data-error-message': _labels.card_number.hint,
			autocomplete: 'off'
		}).data("hint", _labels.card_number.hint)
			.change(function(){
				hiddenField.val($j(this).val());
				$('.cardNumberInput.cardNumber.masked').val($j(this).val());
			}),
		d.input({
			type : 'password',
			className : 'cardNumberInput cardNumber masked ' + (maskCCNumber ? '' : 'hide'),
			name : "cardNumberDummyMasked",
			pattern : '[0-9]*',
			'tabindex': '0',
			'data-luhn': 'true',
			'data-cctype': 'true',
			'data-required': 'true',
			'data-error-message': _labels.card_number.hint,
			autocomplete: 'off'
		}).data("hint", _labels.card_number.hint)
			.change(function(){
				hiddenField.val($j(this).val());
				$('.cardNumberInput.cardNumber.unmasked').val($j(this).val());
			}),
		showCardNumber(maskCCNumber)
		];

		var field = d.fieldLabelPair({
			className : 'cardNumber',
			label : _labels.card_number.label
		}, inputs);

		var label_id = compass.generateId();
		field.find('.cardNumber.fieldLabel').attr('for', label_id);
		_.each(inputs, function (elem) { $(elem).attr({'aria-labelledby': label_id, 'id': label_id}); });

		if (_validator) {
			_.each(field.find("input:not(:checkbox)"), function (input) {
				_validator.addFields($(input), [_skipValidation, _validator.CC], {"allowedCCTypesArray" : _creditCardTypesArray});
			});
		}
		return d.div({ className: 'cardNumberWrapper'}, [field, hiddenField]);
	};

	this.drawCardImages = function() {
		var d = _d;

		var thumbnailArray = $j.map(_creditCardTypesArray,
			function(currentElement) {
				if (currentElement.code === '') { return; }

				return d.div({className:'cardImgDiv'}, d.img({
					className : "cardImg",
					"compass-cc-code" : currentElement.code,
					src : _imgPath + currentElement.code + '.png'
				}));
			}
		);

		return _d.div({
			className : "cardImgDivs"
		}, thumbnailArray, '<div class="floatClear"/>');
	};

	var _expir_val_flag = false;
	window.ParsleyConfig = $.extend(true, {}, window.ParsleyConfig || {}, {
		validators: {
			ccexpiration: function (val, expDate, pars) {
				var $elem = $(pars.element);
				var year, month, assoc;
				var mElem = $elem.attr("data-month"),
					yElem = $elem.attr("data-year");

				var mLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
				if (mElem) {
					year = parseInt(val, 10);
					assoc = $("#" + mElem);
					month = parseInt(assoc.val(), 10)-1;
				} else if (yElem) {
					month = parseInt(val, 10)-1;
					assoc = $("#" + yElem);
					year = parseInt(assoc.val(), 10);
				} else {
					return false;
				}

				expDate = compass.util.parse.ISODateParser(expDate);
				var currDate = new Date(year, month, mLength[month]);

				var res = currDate.valueOf() >= expDate.valueOf();
				if (!_expir_val_flag) {
					_expir_val_flag = true;
					assoc.parsley('needsValidation', true); // Change flag that says to rerun validation
					assoc.parsley('validate');
					_expir_val_flag = false;
				}

				return res;
			},
			luhn: function ( val, elem, self) {  // Pulled from parsley.extend.js
				val = val.replace(/[ -]/g, '');
				var digit, n, sum, _j, _len1, _ref2;
				sum = 0;
				_ref2 = val.split('').reverse();
				for (n = _j = 0, _len1 = _ref2.length; _j < _len1; n = ++_j) {
					digit = _ref2[n];
					digit = +digit;
					if (n % 2) {
						digit *= 2;
						if (digit < 10) {
							sum += digit;
						} else {
							sum += digit - 9;
						}
					} else {
						sum += digit;
					}
				}
				return sum % 10 === 0;
			},
			cctype: function (val, elem, self) {
				var type = _cardType(val);
				return type !== undefined;
			}
		}
	});

	var _expir_ids = [compass.generateId(), compass.generateId()];
	this.drawExpMonth = function() {
		var d = _d;
		var mName = compass.util.dateFormatter('mmmm');
		return d.select({
			name : "expMonth",
			className : "expMonth expMonthSelect",
			id: _expir_ids[0],
			'tabindex': '0',
			'data-ccexpiration': _ISOFormat(_settings.minExpiration),
			'data-year': _expir_ids[1],
			'data-error-message': _labels.expiration_month.hint,
			'aria-label': 'month'
		}, $j.map(["1-Jan", "2-Feb", "3-Mar", "4-Apr", "5-May", "6-Jun", "7-Jul", "8-Aug", "9-Sep", "10-Oct", "11-Nov", "12-Dec"], function(data, i) {
			return d.option({
				value : data.substring(0,data.indexOf('-')),
				'aria-label' : mName(new Date(2014, i, 1))
			}, data.toString());
		})).data("hint", _labels.expiration_month.hint);
	};

	this.drawExpYear = function() {
		var d = _d;
		var now = new Date();
		return d.select({
			name : "expYear",
			className : "expYear",
			'tabindex': '0',
			id: _expir_ids[1],
			'data-ccexpiration': _ISOFormat(_settings.minExpiration),
			'data-month': _expir_ids[0],
			'data-error-message': _labels.expiration_year.hint,
			'aria-label': 'year'
		}, $j.map(_.range(now.getFullYear(), now.getFullYear()+6), function(data, i) {
			return d.option({
				value : data
			}, data.toString());
		}) // make the start year and number of year options...with basic option.
		).data("hint", _labels.expiration_year.hint);
	};

	this.drawNameOnCard = function() {
		var d = _d;
		var field = d.fieldLabelPair({
			className : 'nameOnCard',
			label : _labels.card_name.label
		}, [d.input({
			name : "nameOnCard",
			className : "nameOnCard",
			type : "text",
			id : compass.generateId(),
			'tabindex': '0',
			'data-required': 'true',
			'data-error-message': _labels.card_name.hint,
			'data-parsley-pattern': /[^\d\s\.\/\-]/,  //Contains at least 1 letter
			autocomplete: 'off'
		}).data("hint", _labels.card_name.hint)]);
		if (_validator) {
			_validator.addFields(field.find('input'), [_skipValidation, _validator.NAME], { });
		}
		return field;
	};

	this.drawBillingAddressSameAsMailingCheckbox = function() {
		var d = _d;
		return d.fieldLabelPair({
			className : 'billingAddressSameAsMailing',
			label : 'billing address same as mailing?:'
		}, [d.input({
			name : "billingAddressSameAsMailing",
			className : "billingAddressSameAsMailing",
			'tabindex': '0',
			type : "checkbox"
		})]);
	};

	this.disable = function() {
		_paymentSelection.attr('disabled', true);
	};

	this.enable = function() {
		_paymentSelection.attr('disabled', false);
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'CRAP',
	widgetName : 'CreditCardWidget',
	imgPath : compass.staticPrefix + '/resources/img/compass/demographic/CreditCardWidget/',
	subclass : false,
	displayHeader: false,
	displayCVC : false,
	storedCards: false,
	addressWidget : {},
	minExpiration: new Date(),
	maskCCNumber: false,
	cardWillBeCharged: false,
	cardHasBeenCharged: false,
});

